








































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import echarts from 'echarts';
import EchartOption from '@/common/const/e-chart-options';
import OrganizationSearch from '@/components/organization-search/index.vue';
import _ from 'lodash';
import { commaNumber } from '../format';
import areaMap from '../area';
import china from '../../../assets/map/china.json';
import anhui from '../../../assets/map/province/anhui.json';
import aomen from '../../../assets/map/province/aomen.json';
import beijing from '../../../assets/map/province/beijing.json';
import chongqing from '../../../assets/map/province/chongqing.json';
import fujian from '../../../assets/map/province/fujian.json';
import gansu from '../../../assets/map/province/gansu.json';
import guangdong from '../../../assets/map/province/guangdong.json';
import guangxi from '../../../assets/map/province/guizhou.json';
import guizhou from '../../../assets/map/province/guizhou.json';
import hainan from '../../../assets/map/province/hainan.json';
import hebei from '../../../assets/map/province/hebei.json';
import heilongjiang from '../../../assets/map/province/heilongjiang.json';
import henan from '../../../assets/map/province/henan.json';
import hubei from '../../../assets/map/province/hubei.json';
import hunan from '../../../assets/map/province/hunan.json';
import jiangsu from '../../../assets/map/province/jiangsu.json';
import jiangxi from '../../../assets/map/province/jiangxi.json';
import jilin from '../../../assets/map/province/jilin.json';
import liaoning from '../../../assets/map/province/liaoning.json';
import neimenggu from '../../../assets/map/province/neimenggu.json';
import ningxia from '../../../assets/map/province/ningxia.json';
import qinghai from '../../../assets/map/province/qinghai.json';
import shandong from '../../../assets/map/province/shandong.json';
import shanghai from '../../../assets/map/province/shanghai.json';
import shanxi from '../../../assets/map/province/shanxi.json';
import shanxi1 from '../../../assets/map/province/shanxi1.json';
import sichuan from '../../../assets/map/province/sichuan.json';
import taiwan from '../../../assets/map/province/taiwan.json';
import tianjin from '../../../assets/map/province/tianjin.json';
import xianggang from '../../../assets/map/province/xianggang.json';
import xinjiang from '../../../assets/map/province/xinjiang.json';
import xizang from '../../../assets/map/province/xizang.json';
import yunnan from '../../../assets/map/province/yunnan.json';
import zhejiang from '../../../assets/map/province/zhejiang.json';

@Component({
  components: {
    OrganizationSearch
  }
})
export default class ParkingOverview extends Vue {
  commaNumber: Function = commaNumber;

  // 传入的机构id
  value: string | null = null;

  innerValue: string | null = this.value || null;

  @Watch('value')
  onChangeValue(newValue: string | null) {
    this.innerValue = newValue;
  }

  // @Prop()
  // type: number | null = null

  // 页面数据
  @Prop()
  data: any;

  @Watch('data')
  onDataChange(newValue: any) {
    if (this.data && this.data.nodeParks) {
      const list = [];
      for (const node of this.data.nodeParks) {
        const todayData = this.data.countTodayVos.find((i: { nodeId: any }) => i.nodeId === node.nodeId);
        // @ts-ignore hack
        const name = areaMap[parseInt(node.nodeId)];
        if (!name) {
          continue;
        }
        list.push({
          name,
          nodeId: node.nodeId,
          nodeParkNum: node.nodeParkNum,
          value: node.nodeParkNum,
          ...todayData
        });
      }
      this.mapData = list;
    }
    // this.mapData = newValue && newValue.mapData ? newValue.mapData.map(i=>{
    //   i.value = i.parkingCount
    //   return i
    // }) : []
    this.refreshData();
  }

  // 地图数据
  mapData: any[] = [];

  // 分段图例
  defaultLegendValue: any[] = [
    {
      tip: '大于50',
      value: 0
    },
    {
      tip: '30~50个',
      value: 0
    },
    {
      tip: '10~30个',
      value: 0
    },
    {
      tip: '小于10',
      value: 0
    }
  ];
  legend: any[] = this.defaultLegendValue;
  pieces: any[] = [
    { gt: 50, label: '大于50个', color: 'rgba(11, 132, 255, 0.8)' },
    { gte: 30, lte: 50, label: '30~50个', color: 'rgba(11, 132, 255, 0.6)' },
    { gte: 10, lte: 29, label: '10~29个', color: 'rgba(11, 132, 255, 0.4)' },
    { lt: 10, label: '小于10个', color: 'rgba(11, 132, 255, 0.25)' }
  ];

  refreshData() {
    if (this.mapData && this.mapData.length) {
      const maxValue = _.maxBy<any>(this.mapData, i => i.value).value;
      let ranges = [];
      if (maxValue < 4) {
        ranges = [1, 2, 3];
      } else {
        const tick = Math.round(maxValue / 4);
        ranges = [tick, tick * 2, tick * 3];
      }
      const total = this.mapData.length;
      const arr = [0, 0, 0, 0];
      for (const item of this.mapData) {
        if (item.value < ranges[0]) {
          arr[0]++;
        } else if (item.value >= ranges[0] && item.value < ranges[1]) {
          arr[1]++;
        } else if (item.value >= ranges[1] && item.value <= ranges[2]) {
          arr[2]++;
        } else {
          arr[3]++;
        }
      }
      const newLegend = [];
      newLegend.push({
        tip: `大于${ranges[2]}个`,
        value: Math.round((arr[3] / total) * 100)
      });
      newLegend.push({
        tip: `${ranges[1]}~${ranges[2]}个`,
        value: Math.round((arr[2] / total) * 100)
      });
      newLegend.push({
        tip: ranges[1] - 1 === ranges[0] ? `${ranges[0]}个` : `${ranges[0]}~${ranges[1] - 1}个`,
        value: Math.round((arr[1] / total) * 100)
      });
      newLegend.push({
        tip: `小于${ranges[0]}个`,
        value: Math.round((arr[0] / total) * 100)
      });
      this.legend = newLegend;

      this.pieces = [
        { gt: ranges[2], label: `大于${ranges[2]}个`, color: 'rgba(11, 132, 255, 0.8)' },
        { gte: ranges[1], lte: ranges[2], label: `${ranges[1]}~${ranges[2]}个`, color: 'rgba(11, 132, 255, 0.6)' },
        {
          gte: ranges[0],
          lt: ranges[1],
          label: ranges[1] - 1 === ranges[0] ? `${ranges[0]}个` : `${ranges[0]}~${ranges[1] - 1}个`,
          color: 'rgba(11, 132, 255, 0.4)'
        },
        { lt: ranges[0], label: `小于${ranges[0]}个`, color: 'rgba(11, 132, 255, 0.25)' }
      ];
    } else {
      this.legend = this.defaultLegendValue;
      this.pieces = [];
    }
    this.refreshMap();
  }

  options: EchartOption = new EchartOption();
  isData: boolean = true;

  mapName: String = 'china';
  @Prop()
  provinceId: String = '';
  // 是否钻入省份
  inProvince: boolean = false;

  provinces: any = {
    // 23个省

    台湾: 'taiwan',

    河北: 'hebei',

    山西: 'shanxi',

    辽宁: 'liaoning',

    吉林: 'jilin',

    黑龙江: 'heilongjiang',

    江苏: 'jiangsu',

    浙江: 'zhejiang',

    安徽: 'anhui',

    福建: 'fujian',

    江西: 'jiangxi',

    山东: 'shandong',

    河南: 'henan',

    湖北: 'hubei',

    湖南: 'hunan',

    广东: 'guangdong',

    海南: 'hainan',

    四川: 'sichuan',

    贵州: 'guizhou',

    云南: 'yunnan',

    陕西: 'shanxi1',

    甘肃: 'gansu',

    青海: 'qinghai',

    // 5个自治区

    新疆: 'xinjiang',

    广西: 'guangxi',

    内蒙古: 'neimenggu',

    宁夏: 'ningxia',

    西藏: 'xizang',

    // 4个直辖市

    北京: 'beijing',

    天津: 'tianjin',

    上海: 'shanghai',

    重庆: 'chongqing',

    // 2个特别行政区

    香港: 'xianggang',

    澳门: 'aomen'
  };

  getPopupContainer() {
    return this.$refs.panel;
  }

  get title() {
    return {
      show: false
    };
  }

  get toolTip() {
    return {
      show: true,
      trigger: 'item',
      formatter: function(
        params: {
          data: { parkNum: any; plateNum: any; deviceNum: any; temporaryAmount: any; fixedAmount: any };
          name: any;
        },
        ticket: any,
        callback: any
      ) {
        return params.data
          ? `
        <div class="parking-overview-tooltip">
          <div class="parking-overview-tooltip-title"><span>${params.name}</span> 今日统计</div>
          <div class="parking-overview-tooltip-item v1">车场数量：<span>${
            params.data.parkNum ? params.data.parkNum : 0
          }</span></div>
          <div class="parking-overview-tooltip-item v2">车位数量：<span>${
            params.data.plateNum ? params.data.plateNum : 0
          }</span></div>
          <div class="parking-overview-tooltip-item v3">设备数量：<span>${
            params.data.deviceNum ? params.data.deviceNum : 0
          }</span></div>
          <div class="parking-overview-tooltip-item v4">临停收入：<span>${
            params.data.temporaryAmount ? params.data.temporaryAmount : 0
          }元</span></div>
          <div class="parking-overview-tooltip-item v5">固定车辆收入：<span>${
            params.data.fixedAmount ? params.data.fixedAmount : 0
          }元</span></div>
        </div>
      `
          : '';
      }
    };
  }

  get grid() {
    return {
      top: 20,
      left: 20,
      right: 20,
      bottom: 50
    };
  }

  get visualMap() {
    return {
      show: false,
      orient: 'horizontal',
      left: 'center',
      bottom: 0,
      type: 'piecewise',
      pieces: this.pieces
    };
  }

  get geo() {
    const src = require('@/assets/images/business-overview/map-bg.png');
    const image = new Image();
    image.src = src;
    return {
      map: this.mapName,
      roam: false,
      zoom: 1.23,
      label: {
        normal: {
          show: true,
          color: '#999'
        },
        emphasis: {
          show: false
        }
      },
      itemStyle: {
        normal: {
          borderColor: 'rgba(255, 255, 255, 1)',
          // color: {
          //   image: image, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
          //   repeat: 'repeat', // 是否平铺, 可以是 'repeat-x', 'repeat-y', 'no-repeat'
          // },
          borderWidth: 1,
          color: 'rgba(205, 212, 222, 0.5)'
          // color: 'rgba(11, 132, 255, 0.1)',
        },
        emphasis: {
          areaColor: 'rgba(255, 159, 8, 0.6)',
          borderWidth: 2,
          borderColor: '#fff'
        }
      }
    };
  }

  get series() {
    return [
      {
        name: '车场概况',
        type: 'map',
        geoIndex: 0,
        data: this.mapData
      }
    ];
  }

  // 点击地图
  chartClick(params: { name: string | number; data: { nodeId: any } }) {
    const data = this.mapData.find(i => i.name == params.name);
    // 点击的省份没有数据的话不进行下钻
    if (!data) {
      return;
    }
    if (this.provinces[params.name]) {
      const mapName = this.provinces[params.name];
      this.mapName = mapName;
      this.inProvince = true;
      this.$emit('update:province-id', params.data.nodeId);
    }
  }

  // 返回大地图
  backMap() {
    this.mapName = 'china';
    this.inProvince = false;
    this.$emit('update:province-id', '');
  }

  mounted() {
    this.registerProvinceMap();
    this.refreshMap();
  }

  registerProvinceMap() {
    const chart: any = this.$refs.chart;
    echarts.registerMap('china', this.mapJson['china']);
    for (const k in this.provinces) {
      const mapName = this.provinces[k];
      const src = this.mapJson[mapName];
      echarts.registerMap(mapName, src);
    }
  }

  refreshMap() {
    const options: EchartOption = new EchartOption();
    options.setLegend({
      show: false
    });
    options.setGrid(this.grid);
    options.setVisualMap(this.visualMap);
    options.setTitle(this.title);
    options.setSeries(this.series);
    options.setGeo(this.geo);
    options.setTooltip(this.toolTip);
    this.options = options;
  }

  mapJson: any = {
    china,
    anhui,
    aomen,
    beijing,
    chongqing,
    fujian,
    gansu,
    guangdong,
    guangxi,
    guizhou,
    hainan,
    hebei,
    heilongjiang,
    henan,
    hubei,
    hunan,
    jiangsu,
    jiangxi,
    jilin,
    liaoning,
    neimenggu,
    ningxia,
    qinghai,
    shandong,
    shanghai,
    shanxi,
    shanxi1,
    sichuan,
    taiwan,
    tianjin,
    xianggang,
    xinjiang,
    xizang,
    yunnan,
    zhejiang
  };
}
